<div class="nav-header">
  <img
    *ngIf="mobileHeaderTitle && mobileNavOpen; else logo"
    src="/assets/chevron-left-white.svg"
    alt="Go Back"
    class="nav-header__logo nav-header__logo--back"
    data-automation-id="meganav-go-back-button"
    (click)="onBackClick ? onBackClick() : null"
  />

  <ng-template #logo>
    <a href="/" routerLink="/">
      <img
        src="assets/republic-services-logo-white-text.svg"
        alt="Republic Services Logo"
        class="me-10 nav-header__logo"
      />
    </a>
  </ng-template>

  <p *ngIf="mobileHeaderTitle && mobileNavOpen" class="nav-header__title">
    {{ mobileHeaderTitle }}
  </p>
</div>
